import CentralLink from './CentralLink.js';
import { Button } from 'react-bootstrap';

import { sendNavigateToAnotherSewageReport } from './GoogleAnalytics.js';

function NearBySewagePlace( { place }) {
	return <CentralLink to={"/data-explorer/search-sewage-report/" + place.placeId + "/" + place.placeName} onClick={function() {
		sendNavigateToAnotherSewageReport(place.placeId, place.placeName);
	}}>
		<Button variant="dark" size="sm" style={{marginLeft: "3px", marginRight: "3px", marginTop: "1px", marginBottom: "1px"}}>{place.placeName}</Button>
	</CentralLink>;
}

export default NearBySewagePlace;